export default __webpack_public_path__ + "static/media/i_bus-gen_rd_dup_tagless.0fff4016.svg";